var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "loader",
      class: {
        loader_active: _vm.loading,
        loader_fixed: _vm.height === "fixed",
      },
      style: { height: _vm.height !== "fixed" ? `${_vm.height}px` : "0" },
    },
    [
      _c("div", { staticClass: "loader-overlay" }, [
        _c(
          "div",
          { staticClass: "loader-icon", class: { "mb-25": _vm.label } },
          [_c("font-awesome-icon", { attrs: { icon: _vm.icon, spin: "" } })],
          1
        ),
        _c("div", { staticClass: "loader-label" }, [_vm._v(_vm._s(_vm.label))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }